import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  standalone: true,
  name: 'unixToDate',
  pure: false,
})
export class UnixToDatePipe implements PipeTransform {
  private translateService = inject(TranslocoService);

  transform(value: number, ...args: unknown[]): string {
    const date = new Date(value * 1000);
    const dd = date.getDate();
    const mm = date.getMonth() + 1;
    const yyyy = date.getFullYear();
    if (this.translateService.getActiveLang() === 'de-DE') {
      return `${dd < 10 ? '0' + dd : dd}.${mm < 10 ? '0' + mm : mm}.${yyyy}`;
    } else {
      return `${mm}/${dd}/${yyyy}`;
    }
  }
}
